<div class="mct-flex mct-col mct-gap-27"   *ngIf="customFieldData">
  <div>
    <p-checkbox [(ngModel)]="customFieldData.Required" name="required" [binary]="true" inputId="customFieldRequired"> </p-checkbox>
    <label for="customFieldRequired">
      {{ 'common.required' | translate | titlecase }}
    </label>
  </div>
  <div class="mct-flex mct-col mct-gap-5"  >
    <label> {{ 'form-builder.legos.custom-field' | translate | ucfirst }} </label>
    <p-select
      name="customFieldId"
      appendTo="body"
      [style]="{ width: '100%' }"
      [options]="customFields"
      [(ngModel)]="customFieldData.CustomFieldId"
      (onChange)="customFieldChanged($event.value)"
      [placeholder]="'common.select-one' | translate | ucfirst"
      [required]="true"
    ></p-select>
  </div>
  <div class="mct-flex mct-col mct-gap-5"  >
    <label> {{ 'form-builder.legos.display-name' | translate | ucfirst }} </label>
    <input name="customFieldLabel" class="form-control" [(ngModel)]="customFieldData.Label" />
  </div>
</div>
